const btnStyle = Object.freeze({
  // Border width
  borderBottomWidth: 1,
  borderEndWidth: 1,
  borderStartWidth: 1,
  borderTopWidth: 1,

  // Border style
  borderBottomStyle: 'solid',
  borderEndStyle: 'solid',
  borderStartStyle: 'solid',
  borderTopStyle: 'solid',
  radius: 0,
  boxModel: { hp: 4, vp: 1, },

  // Font Style
  fontWeight: 'bold',
});

export default btnStyle;
